"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var notesContainer = {
    display: 'flex',
    flexDirection: 'column',
    marginTop: widgets_1.TabStyles.Spacing.LargeSpace,
    marginBottom: '16px',
};
exports.notesContainer = notesContainer;
var notesInput = {
    resize: 'none',
    height: '48px',
};
exports.notesInput = notesInput;
//# sourceMappingURL=NotesStyle.js.map